export const compareArrays = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  return arr1.every((obj1, index) => obj1._id === arr2[index]._id);
};
